/**
 * Created by or_p on 7/3/2016.
 */
import _ from 'lodash';
import { PADDING_PROP_NAMES, BORDER_RADIUS_PROP_NAMES } from 'crazyEditor/core/constants/panelConstants';
import {THUMBNAIL_ROW_TRANSITION_DURATION} from 'crazyEditor/core/constants/editorConstants';

function splitStyleValue(value) {
  if (_.isEmpty(value)) {
    return [];
  }
  const result = [];
  let i;
  let lastTokenEnd = 0;
  let parenthesisCount = 0;
  for (i = 0; i < value.length; ++i) {
    if (value[i] === '(') {
      parenthesisCount++;
    } else if (value[i] === ')') {
      parenthesisCount--;
    } else if (value[i] === ',' && parenthesisCount === 0) {
      result.push(value.substring(lastTokenEnd, i).trim());
      lastTokenEnd = i + 1;
    }
  }
  result.push(value.substring(lastTokenEnd, i).trim());
  return result;
}

function getTextureAndGradient(element) {
  const splitBackgroundImage = splitStyleValue(element.compProps.backgroundImage);
  const result = {
    gradient: 'none',
    texture: 'none',
  };
  splitBackgroundImage.forEach((value) => {
    if (value.indexOf('url') === 0) {
      result.texture = value;
    } else if (value.indexOf('gradient') !== -1) {
      result.gradient = value;
    }
  });
  return result;
}

export function getBackgroundTexture(element) {
  const textureAndGradient = getTextureAndGradient(element);
  return textureAndGradient.texture;
}

export function getBackgroundGradient(element) {
  const textureAndGradient = getTextureAndGradient(element);
  return textureAndGradient.gradient;
}

export function getBackgroundTextureSetter(element, texture) {
  const textureAndGradient = getTextureAndGradient(element);
  textureAndGradient.texture = texture ? texture : 'none';
  return {
    compProps: {
      backgroundImage: `${textureAndGradient.gradient}, ${textureAndGradient.texture}`
    }
  };
}

export function getBackgroundGradientSetter(element, gradient) {
  const textureAndGradient = getTextureAndGradient(element);
  textureAndGradient.gradient = gradient ? gradient : 'none';
  return {
    compProps: {
      backgroundImage: `${textureAndGradient.gradient}, ${textureAndGradient.texture}`
    }
  };
}

export function getBorderWidthSetter(borderWidth) {
  return {
    compProps: {
      borderWidth
    }
  };
}

export function getBorderStyleSetter(borderStyle, element) {
  return {
    compProps: {
      borderStyle,
    }
  };
}

export function getBoxShadowSetter(boxShadow) {
  return {
    compProps: {
      boxShadow,
    }
  };
}

export function getBorderRadiusSetter(borderRadius) {
  let result;
  if (_.isObject(borderRadius)) {
    result = {
      compProps: {
        ...borderRadius,
      }
    };
  } else {
    result = {
      compProps: _.zipObject(BORDER_RADIUS_PROP_NAMES, _.times(BORDER_RADIUS_PROP_NAMES.length, _.constant(borderRadius))),
    };
  }
  return result;
}

export function getPaddingSetter(padding) {
  let result;
  if (_.isObject(padding)) {
    result = {
      compProps: {
        ...padding,
      }
    };
  } else {
    result = {
      compProps: _.zipObject(PADDING_PROP_NAMES, _.times(PADDING_PROP_NAMES.length, _.constant(padding))),
    };
  }
  return result;
}

export function getHyperlinkSetter(href) {
  return {
    data: {
      href
    }
  };
}

export function getFontSize(element) {
  let fontSize = _.get(element, 'data.compProps.fontSize');
  if (_.isString(fontSize)) {
    fontSize = parseInt(fontSize, 10);
  }
  return fontSize;
}

export function getBorderWidth(element) {
  let borderWidth = _.get(element, 'compProps.borderWidth');
  if (_.isString(borderWidth)) {
    borderWidth = parseInt(borderWidth, 10);
  }
  return borderWidth;
}

export function buildInteractiveElementsList(element) {
  const pointerElementsStyles = [];
  const elementRect = element.getBoundingClientRect();
  let rect;
  let currStyle;
  _.forEach(element.getElementsByTagName('label'), (currElement) => {
    if (window.getComputedStyle(currElement).visibility !== 'hidden') {
      rect = currElement.getBoundingClientRect();
      if (!(rect.width === 0 && rect.height === 0)) {
        currStyle = {
          position: 'absolute',
          top: rect.top - elementRect.top,
          left: rect.left - elementRect.left,
          width: rect.width,
          height: rect.height,
          cursor: 'pointer',
        };
        if (!_.some(pointerElementsStyles, {'style': currStyle})) {
          pointerElementsStyles.push({
            style: currStyle,
            element: currElement,
          });
        }
      }
    }
  });
  return pointerElementsStyles;
}

export function getElementFontSize(element) {
  const {fontSize} = element.data.compProps;
  let value = 0;
  let unit = null;
  if (typeof fontSize === 'string') {
    value = fontSize.match(/\d+[.]*\d*/)[0];
    unit = fontSize.match(/[^0-9.]+/)[0];
  } else {
    value = fontSize;
  }
  return {value: value, unit: unit};
}


